import { notNull } from 'utils/type_guards';

import type { PickRequired } from 'types/common_types';
import type { CartProduct, CartProductMaybeThumb } from './cart_products.types';

function hasData(cp: CartProduct): cp is CartProductMaybeThumb {
  return !!cp.name;
}

function hasPreviewUrl(cp: CartProduct): cp is PickRequired<CartProduct, 'preview_url'> {
  return notNull(cp.preview_url);
}

export default { hasData, hasPreviewUrl };
